import { mergeFilters, toggleReduxSliceFiltersVisibility } from "@helpers/reduxHelpers.js";
import { createSlice } from "@reduxjs/toolkit";
import FILTERS_KEYS from "@utils/filters_keys.js";
import { REHYDRATE } from "redux-persist/es/constants";

const defaultFilters = [
	{
		id: FILTERS_KEYS.resellers.businessUnits,
		name: "resellers:businessUnitsFilter",
		visible: false,
	},
	{ id: FILTERS_KEYS.resellers.distributors, name: "resellers:distributorsFilter", visible: false },
];
const initialState = {
	data: [],
	defaultFilters: [...defaultFilters],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
};

const resellersSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setResellersData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingResellers: (state, action) => {
			state.loading = action.payload;
		},
		toggleResellersFilterVisibility: toggleReduxSliceFiltersVisibility,
	},
	extraReducers: (builder) => {
		builder.addCase(REHYDRATE, (state, action) => {
			// Get persisted filters
			const persistedFilters =
				action.payload?.modules?.accountManagement.resellers?.filters ?? null;
			// Merge filters with persisted state
			state.filters = mergeFilters(persistedFilters, defaultFilters);
		});
	},
});

export const { setResellersData, setLoadingResellers, toggleResellersFilterVisibility } =
	resellersSlice.actions;
export default resellersSlice.reducer;
